const URL = 'https://awesome-events-back-end.herokuapp.com/';

export default URL;
